import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ActivityPageData {
  active_tab: string;
  recently_viewed: any;
  booked: any;
  enquired: any;
  shortlisted: any;
  shortlistedCount: any;
  shortlistedPageCount: any;
}

export const initialState: ActivityPageData = {
  active_tab: "shortlist",
  recently_viewed: null,
  booked: null,
  enquired: null,
  shortlisted: null,
  shortlistedCount: null,
  shortlistedPageCount: null,
};

const activityPageData = createSlice({
  name: "activityPageData",
  initialState,
  reducers: {
    setActiveTab: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.active_tab = payload;
    },
    setRecentlyViewedData: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.recently_viewed = payload;
    },
    setShortlistedData: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.shortlisted = payload;
    },
    setShortlistedCount: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.shortlistedCount = payload;
    },
    setShortlistedPageCount: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.shortlistedPageCount = payload;
    },
    setBookedData: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.booked = payload;
    },
    setEnquiredData: (state: ActivityPageData, { payload }: PayloadAction<any>) => {
      state.enquired = payload;
    },
  },
});

export default activityPageData.reducer;

export const {
  setActiveTab,
  setRecentlyViewedData,
  setShortlistedData,
  setShortlistedCount,
  setShortlistedPageCount,
  setBookedData,
  setEnquiredData,
} = activityPageData.actions;
